var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { ref: "app", staticClass: "app_css", attrs: { id: "app" } },
    [
      _c("router-view", { attrs: { configObj: _vm.configObj } }),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "用户隐私收集说明",
            visible: _vm.showPrivacyDialog,
            "close-on-click-modal": false,
            "close-on-press-escape": false,
            "show-close": false,
            width: "600px"
          },
          on: {
            "update:visible": function($event) {
              _vm.showPrivacyDialog = $event
            }
          }
        },
        [
          _c(
            "div",
            {
              staticClass: "tip_text_ys",
              staticStyle: { "white-space": "pre-line" }
            },
            [
              _vm._v(
                "为了向您提供更加便捷、高效的服务，本系统部分模块需要采集您的信息数据，并授权学校相关信息系统获得您所填写或留存在学校的身份信息（如姓名、照片、身份证号、学工号等信息）。这些信息将仅用于帮助您在学校不同的信息系统中更快捷地使用相应的服务。\n    "
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "tip_text_ys",
              staticStyle: { "white-space": "pre-line" }
            },
            [
              _vm._v(
                "您同意本协议并开始使用我们的服务后，我们将严格按照《中华人民共和国个人信息保护法》、《" +
                  _vm._s(_vm.configObj.schoolName) +
                  "个人信息保护管理办法》及相关法律法规的要求，使用与保护您的个人信息。感谢您的信任与支持。"
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  attrs: {
                    type: "primary",
                    disabled: _vm.countdown > 0 || _vm.submitting
                  },
                  on: { click: _vm.handleClick }
                },
                [
                  _vm._v("\n        我已知晓\n        "),
                  _vm.countdown > 0
                    ? _c("span", [_vm._v("（" + _vm._s(_vm.countdown) + "s）")])
                    : _vm._e()
                ]
              )
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7ba5bd90", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7ba5bd90","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = null
// module chunks = 